
import React from 'react';

interface NotesSectionProps {
  notes?: string;
}

export const NotesSection: React.FC<NotesSectionProps> = ({ notes }) => {
  if (!notes) {
    return null;
  }

  return (
    <div className="space-y-2">
      <h3 className="text-lg font-medium">Notes</h3>
      <p className="text-sm p-3 bg-muted rounded-md">{notes}</p>
    </div>
  );
};
